import { render, staticRenderFns } from "./FormElementDatePicker.vue?vue&type=template&id=13bc84c1&"
import script from "./FormElementDatePicker.vue?vue&type=script&lang=js&"
export * from "./FormElementDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports